/**
 * UNSEEN module animation helpers
 *
 * The reveal (fade-in + zoom-out) lives in the component's scoped CSS. This
 * module only exposes the reduced-motion check used to short-circuit it.
 */

/**
 * Check if the user prefers reduced motion.
 * @returns {boolean}
 */
export function prefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
